var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayPauseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 27,
    viewBox: "0 0 179 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.37549,
    width: 24,
    height: 24,
    fill: "#8C8C8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.272 12.7601L53.9428 1.83277C54.4153 1.42682 55.1074 1.79284 55.1074 2.44834V9.35984L63.8355 1.83277C64.308 1.42683 65.0001 1.79284 65.0001 2.44835V24.303C65.0001 24.9585 64.308 25.3245 63.8355 24.9185L55.1074 17.3915V24.3029C55.1074 24.9585 54.4153 25.3245 53.9428 24.9185L41.272 13.9912C40.9093 13.6751 40.9093 13.0728 41.272 12.7601Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.618 12.7251L83.2305 1.1798C82.7312 0.750895 82 1.13761 82 1.83019V24.9208C82 25.6134 82.7312 26.0001 83.2305 25.5712L96.618 14.0259C97.0012 13.6954 97.0012 13.0556 96.618 12.7251Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.633 13.9909L124.962 24.9182C124.49 25.3242 123.798 24.9581 123.798 24.3026V17.3911L115.07 24.9182C114.597 25.3241 113.905 24.9581 113.905 24.3026V2.44802C113.905 1.79252 114.597 1.4265 115.07 1.83245L123.798 9.35953V2.44803C123.798 1.79253 124.49 1.42651 124.962 1.83245L137.633 12.7598C137.996 13.0759 137.996 13.6781 137.633 13.9909Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.477 1.37549H162.334V25.3755H159.477V1.37549ZM174.048 1.37549H171.763C171.605 1.37549 171.477 1.50406 171.477 1.6612V25.0898C171.477 25.2469 171.605 25.3755 171.763 25.3755H174.048C174.205 25.3755 174.334 25.2469 174.334 25.0898V1.6612C174.334 1.50406 174.205 1.37549 174.048 1.37549Z",
    fill: "#8C8C8C",
    stroke: "#8C8C8C",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPauseIcon);
export default __webpack_public_path__ + "static/media/PlayPauseIcon.7090e19e4604dfc4381be66927da4fbc.svg";
export { ForwardRef as ReactComponent };